<template>
  <div class="detail-content">
    <div v-if="!loading" class="wrapper" :style="{ height: mainWrapperHeight ? mainWrapperHeight + 'px' : null }">
      <div
        class="inner-wrapper"
        :style="{ height: mainWrapperHeight ? mainWrapperHeight + 'px' : null, overflow: 'hidden' }"
      >
        <div class="main-content" ref="mainWrapper">
          <div v-if="detail && detail.id > 0" class="title">{{ detail.title }}</div>
          <DetailContent v-if="detail && detail.id > 0 && detail.editor_type == 0" :contentData="detail" />
          <DetailJsonContent v-else-if="detail && detail.id > 0 && detail.editor_type == 1" :contentData="detail" />
          <BookContent
            v-else-if="detail && detail.id > 0 && detail.editor_type == 2"
            mode="view"
            :contentData="formatContentData(detail.content_json)"
          />
          <!-- 棕色图鉴 -->
          <ZsTjContent
            v-else-if="
              detail && detail.id > 0 && detail.game && detail.game.alias === 'zsca2' && detail.editor_type == 3
            "
            :detail="detail"
          />
          <!--  Nikke图鉴 -->
          <NikkeTjContent
            v-else-if="
              detail && detail.id > 0 && detail.game && detail.game.alias === 'nikke' && detail.editor_type == 3
            "
            :detail="detail"
          />
        </div>

        <div v-if="detail && detail.id > 0" class="date">
          更新时间：{{ dayjs(detail.updated_at * 1000).format("YYYY-MM-DD") }}
          <a :href="url" target="_blank" class="go-detail">
            进入帖子
          </a>
        </div>
      </div>
    </div>

    <div v-else style="padding: 10px;text-align: center; ">
      <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
        <script
          type="text/javascript"
          src="chrome-extension://kmphamhphplpcjcabjdjjklfjmgkmpba/scripts/overrideRequest.js"
        />
        <defs>
          <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
            <stop stop-color="#15a9d6" stop-opacity="0" offset="0%" />
            <stop stop-color="#15a9d6" stop-opacity=".631" offset="63.146%" />
            <stop stop-color="#15a9d6" offset="100%" />
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(1 1)">
            <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="0.9s"
                repeatCount="indefinite"
              />
            </path>
            <circle fill="#15a9d6" cx="36" cy="18" r="1">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="0.9s"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </g>
      </svg>
    </div>

    <!-- <div class="mask" style="width: 100%;height:100%; position:absolute; left: 0; top: 0;"></div> -->
  </div>
</template>

<script>
import DetailContent from "@/views/wiki/detail/components/detailContent";
// import DetailJsonContent from "@/views/wiki/detail/components/detailJsonContent.vue";
import BookContent from "@/views/editor/wiki-editor/illustrated-book/BookContent.vue";
import ZsTjContent from "@/views/wiki/tj/zs/view/index.vue";
import NikkeTjContent from "@/views/wiki/tj/nikke/view/index.vue";

import dayjs from "dayjs";
// api
import { apiContentDetail } from "@/api/contentApi";

export default {
  name: "DetailRenderComp",
  props: {
    id: {
      type: [String, Number],
      default: ""
    },
    url: {
      type: String,
      default: ""
    }
  },
  components: {
    DetailContent,
    DetailJsonContent: () => import("@/views/wiki/detail/components/detailJsonContent.vue"),
    BookContent,
    ZsTjContent,
    NikkeTjContent
  },
  data() {
    return {
      loading: false,
      detail: null,
      mainWrapperHeight: 0
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    dayjs,
    // 格式化图鉴数据
    formatContentData(content_json) {
      try {
        const contentJson = JSON.parse(content_json || "");
        if (Array.isArray(contentJson)) {
          return contentJson;
        }
        return contentJson.children;
      } catch (error) {
        console.log(error);
      }
    },
    getDetail() {
      this.loading = true;
      apiContentDetail({ id: this.id }).then(async res => {
        if (res.code == 0) {
          this.detail = res.data;
          console.log(this.detail);
          this.loading = false;
          setTimeout(() => {
            const mainWrapperEl = this.$refs.mainWrapper;
            const rect = mainWrapperEl.getBoundingClientRect();
            console.log(rect);
            this.mainWrapperHeight = rect.height;
          }, 20);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.detail-content {
  width: 100%;
  position: relative;

  padding: 5px 5px 34px;
  .wrapper {
    box-sizing: content-box;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 524px;

    /* 滚动槽 */
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 3px;
      background: rgba(0, 0, 0, 0.06);
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.08);
    }

    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: rgba(0, 0, 0, 0.12);
      -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    }
  }
  .main-content {
    width: 878px;
    transform: scale(0.395) translate(-76.5%, -76.5%);
    .title {
      font-weight: bold;
      font-size: 24px;
      color: #333333;
      line-height: 30px;
      text-align: justified;
      font-style: normal;
      text-transform: none;
      margin-bottom: 10px;
    }
  }
  .date {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #e3e3e2;
    font-size: 12px;
    color: #666;
    padding: 0 10px;
    text-align: right;
    .go-detail {
      display: none;
      float: right;
      text-decoration: none;
      color: #666;
    }
  }
}
</style>
